var render = function () {
  var this$1 = this
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "header-left-side", attrs: { id: "header-right" } },
    [
      _vm.debugMode
        ? _c(
            "SupsisButton",
            {
              attrs: { ghost: "" },
              on: {
                click: function () {
                  return (_vm.debugToolVisible = true)
                },
              },
            },
            [_vm._v(" Debug Mode")]
          )
        : _vm._e(),
      _vm._v(" "),
      !_vm.blockedConnection && _vm.isPostitEnabled
        ? _c(
            "md-button",
            {
              directives: [
                {
                  name: "tippy",
                  rawName: "v-tippy",
                  value: {
                    placement: "bottom",
                    theme: _vm.isDarkMode ? "light-border" : "google",
                  },
                  expression:
                    "{\n            placement: 'bottom',\n            theme: isDarkMode ? 'light-border' : 'google',\n        }",
                },
              ],
              staticStyle: {
                "min-width": "fit-content",
                cursor: "pointer",
                display: "flex",
              },
              attrs: {
                content: _vm.$store.state.app.postitBoardVisible
                  ? "Not Tahtasını Kapat"
                  : "Not Tahtasını Aç",
              },
              on: { click: _vm.togglePostitBoard },
            },
            [
              _c(
                "md-icon",
                { style: { color: _vm.darkMode ? "yellow" : "black" } },
                [
                  _vm._v(
                    "\n            " +
                      _vm._s(
                        _vm.$store.state.app.postitBoardVisible
                          ? "close"
                          : "sticky_note_2"
                      ) +
                      "\n        "
                  ),
                ]
              ),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      !_vm.blockedConnection
        ? _c(
            "div",
            {
              staticClass: "header-email-button",
              attrs: { id: "email-icon-header" },
              on: {
                click: function () {
                  return this$1.$router.replace("/mails?selected=My")
                },
              },
            },
            [
              _c("MailIcon", { tag: "component", staticClass: "myIcon" }),
              _vm._v(" "),
              _vm.allUnreadMailCounts !== 0
                ? _c("span", { staticClass: "email-badge" }, [
                    _vm._v(
                      "\n            " +
                        _vm._s(
                          _vm.allUnreadMailCounts > 99
                            ? "99+"
                            : _vm.allUnreadMailCounts
                        ) +
                        "\n        "
                    ),
                  ])
                : _vm._e(),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.CONFIG.FEATURES.HEYSUPSIS_ENABLED && _vm.isTicketPage()
        ? _c(
            "md-button",
            {
              staticClass: "custom-button header-btn btnCopilot",
              attrs: { id: "supsis-copilot" },
              on: {
                click: function ($event) {
                  return _vm.$feature.beforeUseChatCopilot(_vm.activateCopilot)
                },
              },
            },
            [_c("img", { attrs: { src: "/static/img/copilot.png" } })]
          )
        : _vm._e(),
      _vm._v(" "),
      !_vm.blockedConnection ? _c("TodayEvent") : _vm._e(),
      _vm._v(" "),
      !_vm.blockedConnection
        ? _c(
            "a-popover",
            {
              attrs: {
                id: "popoverHelpMenu",
                "data-v-step": "4",
                placement: "bottomRight",
                trigger: "click",
                overlayClassName: "help-menu-popover",
              },
              model: {
                value: _vm.popovers.isHelpMenuPopoverOpen,
                callback: function ($$v) {
                  _vm.$set(_vm.popovers, "isHelpMenuPopoverOpen", $$v)
                },
                expression: "popovers.isHelpMenuPopoverOpen",
              },
            },
            [
              _c("template", { slot: "content" }, [
                _c(
                  "div",
                  {
                    staticClass: "popover-menu-container",
                    attrs: { id: "popoverHelpMenuOpened" },
                  },
                  [
                    _c(
                      "div",
                      {
                        staticClass: "menu-item",
                        on: {
                          click: function ($event) {
                            return _vm.toggleKeyboardShotcutModal(true)
                          },
                        },
                      },
                      [
                        _c(
                          "span",
                          {
                            staticClass: "menu-icon",
                            staticStyle: { color: "#4a6cf7" },
                          },
                          [
                            _c("i", { staticClass: "material-icons" }, [
                              _vm._v("keyboard"),
                            ]),
                          ]
                        ),
                        _vm._v(" "),
                        _c("span", { staticClass: "menu-text" }, [
                          _vm._v(_vm._s(_vm.$t("message.keyboardShortcuts"))),
                        ]),
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "menu-item",
                        on: { click: _vm.showModal },
                      },
                      [
                        _c(
                          "span",
                          {
                            staticClass: "menu-icon",
                            staticStyle: { color: "#3498db" },
                          },
                          [
                            _c("i", { staticClass: "material-icons" }, [
                              _vm._v("description"),
                            ]),
                          ]
                        ),
                        _vm._v(" "),
                        _c("span", { staticClass: "menu-text" }, [
                          _vm._v(_vm._s(_vm.$t("message.supsisDocument"))),
                        ]),
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "menu-item",
                        on: { click: _vm.openNewsModal },
                      },
                      [
                        _c(
                          "span",
                          {
                            staticClass: "menu-icon",
                            staticStyle: { color: "#ff6b35" },
                          },
                          [
                            _c("i", { staticClass: "material-icons" }, [
                              _vm._v("new_releases"),
                            ]),
                          ]
                        ),
                        _vm._v(" "),
                        _c("span", { staticClass: "menu-text" }, [
                          _vm._v(_vm._s(_vm.$t("message.news"))),
                        ]),
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "menu-item",
                        on: { click: _vm.integrationInstruction },
                      },
                      [
                        _c(
                          "span",
                          {
                            staticClass: "menu-icon",
                            staticStyle: { color: "#f64e60" },
                          },
                          [
                            _c("i", { staticClass: "material-icons" }, [
                              _vm._v("support"),
                            ]),
                          ]
                        ),
                        _vm._v(" "),
                        _c("span", { staticClass: "menu-text" }, [
                          _vm._v(_vm._s(_vm.$t("message.notIntegrated"))),
                        ]),
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "menu-item",
                        on: { click: _vm.connectSupportTeamRequest },
                      },
                      [
                        _c(
                          "span",
                          {
                            staticClass: "menu-icon",
                            staticStyle: { color: "#27ae60" },
                          },
                          [
                            _c("i", { staticClass: "material-icons" }, [
                              _vm._v("help_center"),
                            ]),
                          ]
                        ),
                        _vm._v(" "),
                        _c("span", { staticClass: "menu-text" }, [
                          _vm._v(_vm._s(_vm.$t("message.supportUs"))),
                        ]),
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "menu-item",
                        on: { click: _vm.makeBugReport },
                      },
                      [
                        _c(
                          "span",
                          {
                            staticClass: "menu-icon",
                            staticStyle: { color: "#e74c3c" },
                          },
                          [
                            _c("i", { staticClass: "material-icons" }, [
                              _vm._v("report"),
                            ]),
                          ]
                        ),
                        _vm._v(" "),
                        _c("span", { staticClass: "menu-text" }, [
                          _vm._v(_vm._s(_vm.$t("message.reportBug"))),
                        ]),
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "menu-item",
                        on: {
                          click: function ($event) {
                            return _vm.$router.push("/supsis-app")
                          },
                        },
                      },
                      [
                        _c(
                          "span",
                          {
                            staticClass: "menu-icon",
                            staticStyle: { color: "#9b59b6" },
                          },
                          [
                            _c("i", { staticClass: "material-icons" }, [
                              _vm._v("apps"),
                            ]),
                          ]
                        ),
                        _vm._v(" "),
                        _c("span", { staticClass: "menu-text" }, [
                          _vm._v(_vm._s(_vm.$t("message.getApps"))),
                        ]),
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "menu-item",
                        on: {
                          click: function ($event) {
                            return _vm.openWebChat()
                          },
                        },
                      },
                      [
                        _c(
                          "span",
                          {
                            staticClass: "menu-icon",
                            staticStyle: { color: "#1abc9c" },
                          },
                          [
                            _c("i", { staticClass: "material-icons" }, [
                              _vm._v("preview"),
                            ]),
                          ]
                        ),
                        _vm._v(" "),
                        _c("span", { staticClass: "menu-text" }, [
                          _vm._v(_vm._s(_vm.$t("message.visitorScreen"))),
                        ]),
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "menu-item",
                        on: { click: _vm.openIDFinder },
                      },
                      [
                        _c(
                          "span",
                          {
                            staticClass: "menu-icon",
                            staticStyle: { color: "#f1c40f" },
                          },
                          [
                            _c("i", { staticClass: "material-icons" }, [
                              _vm._v("find_in_page"),
                            ]),
                          ]
                        ),
                        _vm._v(" "),
                        _c("span", { staticClass: "menu-text" }, [
                          _vm._v("ID Finder"),
                        ]),
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "menu-item",
                        on: { click: _vm.openQRGenerator },
                      },
                      [
                        _c(
                          "span",
                          {
                            staticClass: "menu-icon",
                            staticStyle: { color: "#9c27b0" },
                          },
                          [
                            _c("i", { staticClass: "material-icons" }, [
                              _vm._v("qr_code"),
                            ]),
                          ]
                        ),
                        _vm._v(" "),
                        _c("span", { staticClass: "menu-text" }, [
                          _vm._v("QR Generator"),
                        ]),
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "menu-item",
                        on: { click: _vm.openWABAPricingTool },
                      },
                      [
                        _c(
                          "span",
                          {
                            staticClass: "menu-icon",
                            staticStyle: { color: "#25d366" },
                          },
                          [
                            _c("i", { staticClass: "material-icons" }, [
                              _vm._v("calculate"),
                            ]),
                          ]
                        ),
                        _vm._v(" "),
                        _c("span", { staticClass: "menu-text" }, [
                          _vm._v("WABA Pricing Tool"),
                        ]),
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "menu-item",
                        on: { click: _vm.openWebhookTool },
                      },
                      [
                        _c(
                          "span",
                          {
                            staticClass: "menu-icon",
                            staticStyle: { color: "#ff9800" },
                          },
                          [
                            _c("i", { staticClass: "material-icons" }, [
                              _vm._v("webhook"),
                            ]),
                          ]
                        ),
                        _vm._v(" "),
                        _c("span", { staticClass: "menu-text" }, [
                          _vm._v("Webhook Tool"),
                        ]),
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "menu-item",
                        on: { click: _vm.openWhatsappComparison },
                      },
                      [
                        _c(
                          "span",
                          {
                            staticClass: "menu-icon",
                            staticStyle: { color: "#25d366" },
                          },
                          [
                            _c("i", { staticClass: "material-icons" }, [
                              _vm._v("compare"),
                            ]),
                          ]
                        ),
                        _vm._v(" "),
                        _c("span", { staticClass: "menu-text" }, [
                          _vm._v("WhatsApp Solutions Comparison"),
                        ]),
                      ]
                    ),
                    _vm._v(" "),
                    _c("div", { staticClass: "menu-divider" }),
                    _vm._v(" "),
                    _c("div", { staticClass: "menu-item version-item" }, [
                      _c(
                        "span",
                        {
                          staticClass: "menu-icon",
                          staticStyle: { color: "#2ecc71" },
                        },
                        [
                          _c("i", { staticClass: "material-icons" }, [
                            _vm._v("done"),
                          ]),
                        ]
                      ),
                      _vm._v(" "),
                      _c("span", { staticClass: "menu-text" }, [
                        _vm._v("SUPSIS " + _vm._s(_vm.version.versionStr)),
                      ]),
                    ]),
                    _vm._v(" "),
                    _c("AnnouncementNotifications"),
                  ],
                  1
                ),
              ]),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "header-info-button",
                  class: { infoLight: _vm.unreadAnnouncements },
                },
                [
                  _vm.unreadAnnouncements
                    ? _c(
                        "a-badge",
                        { attrs: { color: "#F64E60" } },
                        [
                          _c("InfoIcon", {
                            tag: "component",
                            staticClass: "myIcon",
                          }),
                        ],
                        1
                      )
                    : _c("InfoIcon", {
                        tag: "component",
                        staticClass: "myIcon",
                      }),
                ],
                1
              ),
            ],
            2
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        { attrs: { id: "notifications" } },
        [
          !_vm.blockedConnection
            ? _c(
                "a-popover",
                {
                  attrs: {
                    placement: "bottomRight",
                    trigger: "click",
                    overlayClassName: "no-padding notification-popover",
                  },
                  model: {
                    value: _vm.popovers.notifications,
                    callback: function ($$v) {
                      _vm.$set(_vm.popovers, "notifications", $$v)
                    },
                    expression: "popovers.notifications",
                  },
                },
                [
                  _c(
                    "template",
                    { slot: "content" },
                    [
                      _vm.popovers.notifications
                        ? _c("NotificationPanel")
                        : _vm._e(),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "header-notification-button" },
                    [
                      _c("NotificationIcon", {
                        tag: "component",
                        staticClass: "myIcon",
                      }),
                      _vm._v(" "),
                      _vm.unreadNotificationCount !== 0
                        ? _c("span", { staticClass: "notification-badge" }, [
                            _vm._v(
                              "\n                    " +
                                _vm._s(
                                  _vm.unreadNotificationCount > 99
                                    ? "99+"
                                    : _vm.unreadNotificationCount
                                ) +
                                "\n                "
                            ),
                          ])
                        : _vm._e(),
                    ],
                    1
                  ),
                ],
                2
              )
            : _vm._e(),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "header-selection-item" },
        [
          _vm.adminUser
            ? _c(
                "b-dropdown",
                {
                  staticClass: "h-100",
                  attrs: {
                    id: "user-dropdown",
                    text: _vm.adminUser.email,
                    right: "",
                  },
                },
                [
                  _c("template", { slot: "button-content" }, [
                    _c("img", {
                      staticClass: "rounded-circle mx-1",
                      attrs: {
                        alt: "Kullanıcı resmi",
                        src: "https://placeimg.com/30/30/people",
                      },
                    }),
                    _vm._v(" "),
                    _c("small", [_vm._v(_vm._s(_vm.adminUser.name))]),
                  ]),
                  _vm._v(" "),
                  _c(
                    "b-dropdown-item",
                    {
                      staticClass: "mt-2",
                      on: {
                        click: function ($event) {
                          $event.preventDefault()
                          return _vm.logout.apply(null, arguments)
                        },
                      },
                    },
                    [
                      _c("font-awesome-icon", {
                        staticClass: "mr-2",
                        attrs: { icon: "sign-out-alt" },
                      }),
                      _vm._v(
                        "\n                " +
                          _vm._s(_vm.$t("message.logout")) +
                          "\n            "
                      ),
                    ],
                    1
                  ),
                ],
                2
              )
            : _vm._e(),
          _vm._v(" "),
          _c(
            "a-modal",
            {
              attrs: {
                id: "conversation-color-help2",
                footer: null,
                title: _vm.$t("message.chatColorMeanings"),
                visible: _vm.chatColorModalVisible,
              },
              on: {
                cancel: function ($event) {
                  return _vm.toggleChatColorModal(false)
                },
                ok: function ($event) {
                  return _vm.toggleChatColorModal(false)
                },
              },
            },
            [_c("ConversationColorHelp")],
            1
          ),
          _vm._v(" "),
          _c(
            "a-modal",
            {
              attrs: {
                id: "ShortcutModal",
                footer: null,
                title: _vm.$t("message.keyboardShortcuts"),
                visible: _vm.keyboardShortCutsModalVisible,
              },
              on: {
                cancel: function ($event) {
                  return _vm.toggleKeyboardShotcutModal(false)
                },
              },
            },
            [_c("KeyboardShortcuts")],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "a-modal",
        {
          staticClass: "debug-tool-modal-wrapper",
          attrs: { title: "Debug Tool", footer: null },
          model: {
            value: _vm.debugToolVisible,
            callback: function ($$v) {
              _vm.debugToolVisible = $$v
            },
            expression: "debugToolVisible",
          },
        },
        [_c("DebugTool")],
        1
      ),
      _vm._v(" "),
      _c(
        "a-modal",
        {
          staticClass: "custom-modal",
          attrs: {
            visible: _vm.visible,
            "cancel-text": null,
            width: 1150,
            footer: false,
            "footer-hide": true,
          },
          on: {
            "update:visible": function ($event) {
              _vm.visible = $event
            },
            ok: _vm.handleOk,
            cancel: function ($event) {
              _vm.visible = false
            },
          },
        },
        [
          _c("div", { staticStyle: { height: "700px" } }, [
            _c("iframe", {
              staticStyle: { width: "100%", height: "100%", border: "none" },
              attrs: { src: "https://doc.supsis.live/" },
            }),
          ]),
        ]
      ),
      _vm._v(" "),
      _c(
        "a-modal",
        {
          staticClass: "custom-modal qr-generator-modal",
          attrs: {
            visible: _vm.qrGeneratorModalVisible,
            "cancel-text": null,
            width: 1200,
            footer: false,
            "footer-hide": true,
            title: "QR Generator",
          },
          on: {
            "update:visible": function ($event) {
              _vm.qrGeneratorModalVisible = $event
            },
            ok: function () {
              return (_vm.qrGeneratorModalVisible = false)
            },
            cancel: function ($event) {
              _vm.qrGeneratorModalVisible = false
            },
          },
        },
        [
          _c("div", { staticStyle: { height: "700px" } }, [
            _c("iframe", {
              staticStyle: { width: "100%", height: "100%", border: "none" },
              attrs: {
                src: "https://qr.supsis.ai",
                allow:
                  "camera; microphone; geolocation; fullscreen; autoplay; payment; vr; web-share; accelerometer; gyroscope; magnetometer; picture-in-picture; display-capture; clipboard-read; clipboard-write; usb; bluetooth; serial; hid",
                sandbox:
                  "allow-same-origin allow-scripts allow-popups allow-forms allow-pointer-lock allow-orientation-lock allow-modals allow-downloads allow-popups-to-escape-sandbox allow-presentation allow-storage-access-by-user-activation allow-top-navigation allow-top-navigation-by-user-activation",
              },
            }),
          ]),
        ]
      ),
      _vm._v(" "),
      _c(
        "a-modal",
        {
          staticClass: "custom-modal waba-pricing-modal",
          attrs: {
            visible: _vm.wabaPricingModalVisible,
            "cancel-text": null,
            width: 1200,
            footer: false,
            "footer-hide": true,
            title: "WABA Pricing Tool",
          },
          on: {
            "update:visible": function ($event) {
              _vm.wabaPricingModalVisible = $event
            },
            ok: function () {
              return (_vm.wabaPricingModalVisible = false)
            },
            cancel: function ($event) {
              _vm.wabaPricingModalVisible = false
            },
          },
        },
        [
          _c("div", { staticStyle: { height: "85vh" } }, [
            _c("iframe", {
              staticStyle: { width: "100%", height: "100%", border: "none" },
              attrs: {
                src: "https://wabapricing.supsis.ai",
                allow:
                  "camera; microphone; geolocation; fullscreen; autoplay; payment; vr; web-share; accelerometer; gyroscope; magnetometer; picture-in-picture; display-capture; clipboard-read; clipboard-write; usb; bluetooth; serial; hid",
                sandbox:
                  "allow-same-origin allow-scripts allow-popups allow-forms allow-pointer-lock allow-orientation-lock allow-modals allow-downloads allow-popups-to-escape-sandbox allow-presentation allow-storage-access-by-user-activation allow-top-navigation allow-top-navigation-by-user-activation",
              },
            }),
          ]),
        ]
      ),
      _vm._v(" "),
      _c(
        "a-modal",
        {
          staticClass: "custom-modal whatsapp-comparison-modal",
          attrs: {
            visible: _vm.whatsappComparisonModalVisible,
            "cancel-text": null,
            width: 1400,
            footer: false,
            "footer-hide": true,
            title: "WhatsApp Solutions Comparison",
          },
          on: {
            "update:visible": function ($event) {
              _vm.whatsappComparisonModalVisible = $event
            },
            ok: function () {
              return (_vm.whatsappComparisonModalVisible = false)
            },
            cancel: function ($event) {
              _vm.whatsappComparisonModalVisible = false
            },
          },
        },
        [_c("WhatsappComparison")],
        1
      ),
      _vm._v(" "),
      _c("NewsModal", { ref: "newsModal" }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }